import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import AppNavBar from '../components/AppNavBar'
import Container from 'react-bootstrap/Container';
import { useAuth } from "../context/AuthProvider";
import { Alert, Badge, Button, Card, Col, Form, Nav, Row, Spinner } from "react-bootstrap";
import MfaSettings from '../components/MfaSettings';
import PasswordSettings from '../components/PasswordSettings';
import { PersonVcard, ShieldLock } from 'react-bootstrap-icons';

import ListeAnnuaire from '../test.json';

export default function Account() {
  const [loading, setLoading] = useState(true)
  const [firstName, setFirstName] = useState(null)
  const [lastName, setLastName] = useState(null)
  const [avatar_url, setAvatarUrl] = useState(null)
  const [etablissement, setEtablissement] = useState(null);
  const [profile, setProfile] = useState(null);
  const { user, auth, userRole } = useAuth();
  // Section affichée à droite du menu : 'identifiants' ou 'securite'.
  const [section, setSection] = useState('identifiants');
  const [saved, setSaved] = useState(false);


  useEffect(() => {
    async function getProfile() {
      setLoading(true)
      let { data, error } = await supabase
        .from('profiles')
        .select('first_name, last_name, avatar_url, etablissement, profile')
        .eq('id', user.id)
        .single()

      if (error) {
        console.warn(error)
      } else if (data) {
        console.log(data);
        console.log(data.first_name);
        setFirstName(data.first_name);
        setLastName(data.last_name);
        setAvatarUrl(data.avatar_url);
        setEtablissement(data.etablissement);
        setProfile(data.profile);
      }

    console.log(user?.app_metadata?.claims_admin);
      console.log(user)
      console.log(auth);

      setLoading(false);
    }

    console.log("Nb items dans l'annuaire : " + ListeAnnuaire.length);

    getProfile();
  }, [user, auth]);

  async function updateProfile(event, avatarUrl) {
    event.preventDefault()

    setLoading(true);

    const updates = {
      id: user.id,
      first_name: firstName,
      last_name: lastName,
      avatarUrl,
      updated_at: new Date(),
    }

    let { error } = await supabase.from('profiles').upsert(updates)

    if (!error) {
      // La barre de menu affiche le nom depuis user_metadata (renseigné à l'inscription) : on le synchronise.
      // L'événement USER_UPDATED met à jour l'utilisateur dans AuthProvider, donc la barre de menu.
      ({ error } = await supabase.auth.updateUser({ data: { first_name: firstName, last_name: lastName } }))
    }

    if (error) {
      alert(error.message)
    } else {
      setAvatarUrl(avatarUrl)
      setSaved(true)
    }
    setLoading(false)
  }


  
  return (
    <div>

    <AppNavBar />
    <Container className="mt-3 account-page">
    <Row>
    <Col md={3} className="mb-3">
      <Nav variant="pills" className="flex-column account-menu" activeKey={section} onSelect={(key) => setSection(key)}>
        <Nav.Item>
          <Nav.Link eventKey="identifiants"><PersonVcard size={18} />Identifiants</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="securite"><ShieldLock size={18} />Sécurité</Nav.Link>
        </Nav.Item>
      </Nav>
    </Col>
    <Col md={9}>
    {section === 'securite' ? (
    <>
    <Card className="account-card mb-3">
        <Card.Body>
          <PasswordSettings />
        </Card.Body>
    </Card>
    <Card className="account-card">
        <Card.Body>
          <MfaSettings />
        </Card.Body>
    </Card>
    </>
    ) : (
    <Card className="account-card">
        <Card.Body>
    <h5 className="account-card-title"><PersonVcard size={20} />Identifiants</h5>
    <p className="text-muted">Vos informations personnelles et votre rattachement.</p>
    <Form onSubmit={updateProfile}>
      <Form.Group className="mb-3" controlId="email">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" value={user.email} disabled />
      </Form.Group>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3" controlId="firstName">
            <Form.Label>Prénom</Form.Label>
            <Form.Control
              type="text"
              required
              value={firstName || ''}
              onChange={(e) => { setFirstName(e.target.value); setSaved(false); }}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3" controlId="lastName">
            <Form.Label>Nom</Form.Label>
            <Form.Control
              type="text"
              required
              value={lastName || ''}
              onChange={(e) => { setLastName(e.target.value); setSaved(false); }}
            />
          </Form.Group>
        </Col>
      </Row>

      <h6 className="account-section-title">Rattachement</h6>
      <dl className="row account-details">
        <dt className="col-sm-4">Établissement</dt>
        <dd className="col-sm-8">{etablissement || '—'}</dd>
        <dt className="col-sm-4">Profil</dt>
        <dd className="col-sm-8">{profile || '—'}</dd>
        <dt className="col-sm-4">Rôle</dt>
        <dd className="col-sm-8">
          {userRole ? <Badge className="account-badge">{userRole}</Badge> : '—'}
          {user?.app_metadata?.claims_admin ? <Badge className="account-badge ms-2">Admin</Badge> : null}
        </dd>
        {avatar_url ? (
          <>
            <dt className="col-sm-4">Avatar</dt>
            <dd className="col-sm-8 text-truncate"><small className="text-muted">{avatar_url}</small></dd>
          </>
        ) : null}
      </dl>

      {saved && (
        <Alert variant="success" onClose={() => setSaved(false)} dismissible>
          Profil mis à jour.
        </Alert>
      )}
      <div className="d-flex justify-content-end">
        <Button type="submit" disabled={loading}>
          {loading ? <><Spinner animation="border" size="sm" className="me-2" />Enregistrement...</> : 'Enregistrer'}
        </Button>
      </div>
    </Form>
    </Card.Body>
    </Card>
    )}
    </Col>
    </Row>
    </Container>
    </div>


  )
}